/*eslint-disable */
import request from '../../Utils/curl'
import Utility from "../../Utils/utility"

let UniversityCourses = {
  /**
   * organisationCourseList
   */
  async organisationCourseList (context, payload, filter = {}) {
    Utility.showLoader = true;
    Utility.loadingMsg = "Please wait...."; 
    try{
      let post_data = new FormData();
  
      for (let key in payload) {
        if (payload[key]) {
          post_data.append(key, payload[key])
        }
      }

      post_data.append('filter', JSON.stringify(filter));

      return await request.curl(context, "organisation_course_list", post_data)
        .then(async response => {
          return response
        });

    }
    catch(err){
      console.error('Exception occurred at organisationCourseList() and Exception:',err.message)
    }
    finally{
      Utility.showLoader = false;
    }
  },

  /**
   * organisationCourseView
   */
  async organisationCourseView (context, organisationCourseId) {
    try {      
      let post_data = new FormData();
      post_data.append('cour_id', organisationCourseId);
      return await request.curl(context, "organisation_course_view", post_data)
      .then(async response => {
        return response;
      });
    } 
    catch (err) {
      console.error("Exception occurred at organisationCourseView() and Exception:",err.message)
    }    
  },

  /**
   * organisationCourseAdd
   */
  async organisationCourseAdd (context, organisationCourseObj) {
    try{
      let post_data = new FormData();
    
      for (let key in organisationCourseObj) {
        post_data.append(key, organisationCourseObj[key]);
      }

      return await request.curl(context, "organisation_course_add", post_data)
      .then(async response => {
          return response;
      });
    }
    catch(err){
      console.error('Exception occurred at organisationCourseAdd() and Exception:',err.message)
    }
  },

  /**
   * organisationCourseEdit
   */
  async organisationCourseEdit (context, organisationCourseObj) {
    try{
      let post_data = new FormData();
    
      for (let key in organisationCourseObj) {
        post_data.append(key, organisationCourseObj[key]);
      }

      return await request.curl(context, "organisation_course_edit", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.error('Exception occurred at organisationCourseEdit() and Exception:',err.message)
    }
  },

  /**
   * organisationCourseDelete
   */
  async organisationCourseDelete (context, organisationCourseId) {
    try{
      let post_data = new FormData();
      
      post_data.append('cour_id', organisationCourseId);

      return await request.curl(context, "organisation_course_delete", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.log('Exception occurred at organisationCourseDelete() and Exception:',err.message)
    }
  },
  
  /**
   * organisationCourseFilterGet
   */
  async organisationCourseFilterGet (context, orgCourseObj = {}) {
    try {
      let postData = new FormData()

      if (orgCourseObj.wherefilter && Object.keys(orgCourseObj.wherefilter).length > 0) {
        postData.append("filter", JSON.stringify(orgCourseObj.wherefilter))
      }

      for (let key in orgCourseObj) {
        if (key !== "wherefilter") {
          postData.append(key, orgCourseObj[key])
        }
      }

      return await request.curl(context, "organisation_course_filter_get", postData)
      .then(async response => {
        return response
      })
    }
    catch (err) {
      console.error("Exception occurred at organisationCourseFilterGet() and Exception:", err.message)
    }
  },

  /**
   * courseOrgnisationList
   */
  async courseOrgnisationList (context, whereFilter=null) {
    try{
      let post_data = new FormData();
    
      if (whereFilter) {
        post_data.append('filter', JSON.stringify(whereFilter))
      }

      return await request.curl(context, "course_organisation_list", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.error('Exception occurred at courseOrgnisationList() and Exception:',err.message)
    }
  },

  /**
   * Search Career Course List
   */
  async SearchcareerCourseList (context, filter = {}) {
    try {
      let postData = new FormData()

      if (Object.keys(filter).length > 0) {
        postData.append("filter", JSON.stringify(filter))
      }

      return await request.curl(context, "career_course_list_search", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at SearchcareerCourseList() and Exception:", err.message)
    }
  }
}

export {
  UniversityCourses
}
